import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplyService {
  constructor(private http: HttpClient) { }

  // seeker
  getByJobId(jobId: string) {
    return this.http.get(environment.app.apiUrl + 'apply/get/' + jobId).toPromise();
  }
  // seeker
  getByRequestId(requestId: string) {
    return this.http.get(environment.app.apiUrl + 'apply/get-request-id/' + requestId).toPromise();
  }

  acceptRequest(id: any): any {
    return this.http.post(environment.app.apiUrl + 'apply/accept-request/' + id, null).toPromise();
  }
  rejectRequest(id: any): any {
    return this.http.post(environment.app.apiUrl + 'apply/reject-request/' + id, null).toPromise();
  }
  // seeker
  seeker(from = 0, limit = 10) {
    return this.http.post<{ total: number, applies: any[] }>(environment.app.apiUrl + 'apply/seeker', { from, limit }).toPromise();
  }

  seekerCounts() {
    return this.http.get<any>(environment.app.apiUrl + 'apply/seeker/count').toPromise();
  }

  // employer|agent
  owner(criteria: any, from: number = 0, limit: number = 50) {
    return this.http.post<{ total: number, applies: any[] }>(environment.app.apiUrl + `apply/list/${from}/${limit}`, criteria).toPromise();
  }

  ownerGetById(applyId: string): any {
    return this.http.get<any>(environment.app.apiUrl + `apply/owner/${applyId}`).toPromise();
  }
  ownerGetByUserId(userId: string): any {
    return this.http.get<any>(environment.app.apiUrl + `apply/owner/user/${userId}`).toPromise();
  }
  ownerGetListMetadata() {
    return this.http.get<any>(environment.app.apiUrl + `apply/owner/list-metadata`, { headers: { 'x-kp-alive': 'true' } }).toPromise();
  }

  // employer|agent
  ownerUpdate(apply: any) {
    return this.http.post<any>(environment.app.apiUrl + 'apply/update/' + apply.Id, apply).toPromise();
  }

  cancel(applyId: string) {
    return this.http.post(environment.app.apiUrl + 'apply/cancel/' + applyId, null).toPromise();
  }

  getJobApplies(jobIds: string[]) {
    if (!jobIds || !jobIds.length) { return null; }
    return this.http.post<any[]>(environment.app.apiUrl + 'apply/job-applies', jobIds).toPromise();
  }

  sendResumeRequests(seekerIds: string[], jobId: string, tags: any[], newJob: any) {
    return this.http.post<any[]>(environment.app.apiUrl + 'apply/send-resume-requests', { seekerIds, jobId, tags, newJob }).toPromise();
  }
  adminSendResume( payload: { jobId: string, ownerId: string, selectedSeekers: { id: string, sendSms: boolean }[] }) {
  return this.http.post<number>(environment.app.apiUrl + 'apply/admin-send-resume', payload).toPromise();
  }


  adminRemoveResume(id: string) {
    return this.http.post(environment.app.apiUrl + `apply/admin-remove-resume/${id}`, null).toPromise();
  }

  cancelResumeRequest(id: string) {
    return this.http.post<any>(environment.app.apiUrl + `apply/cancel-resume-request/${id}`, {}).toPromise();
  }

  getAppliesByJobId(jobId: string, from: number = 0, limit: number = 100) {
    return this.http.get<any>(
      `${environment.app.apiUrl}apply/applies/${jobId}?from=${from}&limit=${limit}`
    ).toPromise();
  }

}
